module.exports = __webpack_public_path__ + "static/img/68.66b15a6.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/68.png
// module id = O4Zk
// module chunks = 1